<template>
  <!--------------------------------------
    Grid element to contain a few data points for congressional profiles. Fill with <ProfileDataPoint> elements.
  ---------------------------------------->
  <div class="profile-data-element" :class="classes">
    <div class="element-title">{{ title }}</div>
    <div class="element-contents">
      <slot></slot>
    </div>
    <div class="element-icon" v-if="icon">
      <v-icon :color="shaded === true ? '#fff' : '#eef4f9'" size="60">
        {{ icons[icon] }}
      </v-icon>
    </div>
  </div>
</template>

<script>
import { mdiAccountMultiple, mdiScaleBalance, mdiHomeVariantOutline, mdiGavel, mdiCurrencyUsd, mdiHandshake } from '@mdi/js';

export default {
  name: 'ProfileDataElement',

  props: {
    title: { type: String, required: false },
    icon: { type: String, required: false },
    shaded: { type: Boolean, required: false, default: true }, // light blue shading and white icon (if true) or vice versa?
    bordered: { type: Boolean, required: false, default: true } // false makes the border white but it will still be present for the sake of consistent content positioning
  },

  data () {
    return {
      icons: {
        'people': mdiAccountMultiple,
        'scale': mdiScaleBalance,
        'house': mdiHomeVariantOutline,
        'gavel': mdiGavel,
        'dollar': mdiCurrencyUsd,
        'handshake': mdiHandshake
      }
    }
  },

  computed: {
    classes() {
      let c = []
      c[0] = this.shaded === true ? 'shaded' : 'not-shaded'
      c[1] = this.bordered === true ? 'bordered' : 'not-bordered'
      return c.join(' ')
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';

.profile-data-element {
  padding: 1rem 0.75rem 0.75rem 0.75rem;
  position: relative;
  height: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  box-shadow: rgb(17 17 26 / 5%) 2px 4px 13px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &.shaded {
    background-color: $extra-subtle-blue;
  }
  &.bordered {
    border: 0.4rem solid $extra-subtle-blue;
  }
  &.not-bordered {
    border: 0.4rem solid #fff;
  }

  .element-title {
    color: #001f60;
    padding-bottom: 0.5rem;
    font-family: 'Work Sans', sans-serif;
    text-transform: uppercase;
    font-weight: 400;
    letter-spacing: 0.04rem;
    z-index: 1;
    position: relative;
    font-size: 1.1rem;
    letter-spacing: 0.05rem;
  }
  .element-contents {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex-grow: 1;
  }
  .element-icon {
    position: absolute;
    right: 0.25rem;
    top: -0.25rem;
    z-index: 0;
  }

  // PRINT-VERSION-SPECIFIC
  &.print-v {
    font-size: 0.85rem;

    .element-title {
      font-size: 0.85rem;
      letter-spacing: normal;
    }
  }
}
</style>